import { isInsightsEnabled } from '../../common/constants'
import { useUserHasScopedBlockAccess, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { useIsFeatureAdvertisementEnabled } from '../../common/useIsFeatureAdvertisementEnabled'

export const useIsInsightsVisible = ({ requireScope = true }: { requireScope?: boolean } = {}): {
  insightsVisible: boolean
  isFetching: boolean
} => {
  const { userHasScopedBlockAccess } = useUserHasScopedBlockAccess()
  const [hasInsightsScope] = userHasScopedBlockAccess([], undefined, { scope: 'insights:read', superScope: [] })

  const { hasQuota, isFetching: isQuotaFetching } = useZocksQuota()
  const {
    isEnabled: adEnabled,
    isFetching: isAdFetching,
    isLoading: isAdLoading,
  } = useIsFeatureAdvertisementEnabled({
    bypass: hasQuota('insights.enabled.value'),
  })

  return {
    insightsVisible: isInsightsEnabled() && (hasInsightsScope || !requireScope) && adEnabled,
    isFetching: isQuotaFetching || isAdFetching || isAdLoading,
  }
}
